module.exports = __webpack_public_path__ + "img/sam.0bf3a2ae.svg";